export * from "./types";
export * from "./registry";

import { recommendationRegistry } from "./registry";
import { assessmentRecommendationHandler } from "./handlers/assessmentHandler";
import { azureRecommendationHandler } from "./handlers/azureHandler";
import { awsRecommendationHandler } from "./handlers/awsHandler";

recommendationRegistry.register(assessmentRecommendationHandler);
recommendationRegistry.register(azureRecommendationHandler);
recommendationRegistry.register(awsRecommendationHandler);

export { assessmentRecommendationHandler } from "./handlers/assessmentHandler";
export { azureRecommendationHandler } from "./handlers/azureHandler";
export { awsRecommendationHandler } from "./handlers/awsHandler";
